import React from 'react';
import { IIconProps } from '../IIconProps';

export const ChevronIcon = ({
	iconClass = '',
	title = '',
	pointer,
	onClick,
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 7 13"
			className={`${iconClass} ${pointer || onClick ? 'icon--pointer' : ''}`}
			onClick={onClick}
		>
			{title && <title>{title}</title>}
			<path fill="none" d="M1 1L6 6.5L1 12" strokeWidth={1} />
		</svg>
	);
};
